import { PropertyType } from '../config/property';
import propertyService from '../service/property.service';

export const getDynVal = (dinVals, fieldName) => {
  if (!dinVals) return;
  const fieldId = parseInt(fieldName.slice('dynamicFields.din_'.length));
  return dinVals.find((v) => v.propertyId === fieldId);
};

export const getIndex = (fieldName) => {
  return fieldName.slice('dynamicFields.'.length);
};

export const getMultiFieldHeight = (characterLength) => {
  if (characterLength > 1 && characterLength <= 47) {
    return 1;
  } else if (characterLength > 47 && characterLength <= 94) {
    return 2;
  } else if (characterLength > 94 && characterLength <= 141) {
    return 3;
  } else if (characterLength > 141 && characterLength <= 188) {
    return 4;
  } else if (characterLength > 188 && characterLength <= 235) {
    return 5;
  } else if (characterLength > 235 && characterLength <= 282) {
    return 6;
  } else if (characterLength > 282 && characterLength <= 329) {
    return 7;
  } else {
    return 1;
  }
};

export const getDynEmptyVal = (type) => {
  return type === PropertyType.DATE ? null : '';
};

export const getDynVals = (dynFields, dynVals = []) => {
  return dynFields.reduce((acc, row) => {
    const findedProp = dynVals.find((val) => val.property.id === row.property.id);

    const findedVal =
      findedProp?.textVal ||
      findedProp?.numberVal ||
      findedProp?.longTextVal ||
      findedProp?.dateVal ||
      findedProp?.comboBoxVal;

    acc[`din_${row.property.id}`] = findedVal || row.property.defaultValue || getDynEmptyVal(row.property.type);
    return acc;
  }, {});
};

const getRelevantFields = (allFields, dynVals) => {
  return dynVals.filter((field) => {
    return allFields.some((val) => val.property.id === field.propertyId);
  });
};

/**
 * Copies dynamic field values from the source values to the target fields
 * determined by the dynamic field definitions.
 *
 * @param {Object<string, any>} dynProps - Dynamic field definitions describing which fields should receive updated values.
 * @param {Object<string, any>} dynVals - Source values containing the data used to populate the target dynamic fields.
 * @param {(path: string, value: any) => void} setFieldValue - Function used to update form field values.
 * @returns {void}
 */

export const copyDynVals = (dynProps, dynVals, setFieldValue) => {
  const copiedFields = getRelevantFields(dynProps, dynVals);
  const newDynVals = getDynVals(copiedFields, dynVals);

  Object.keys(newDynVals).forEach((key) => {
    setFieldValue(`dynamicFields.${key}`, newDynVals[key]);
  });
};

export const emptyDynFieldsAfterCopy = async (dynProps, submenuId, setFieldValue) => {
  try {
    if (!submenuId) throw new Error('submenuId is required');

    const copiedProps = await propertyService.getPropertiesByFormId(submenuId);

    const fieldsToEmpty = copiedProps.filter((prop) =>
      dynProps.some((field) => field.property.id === prop.property.id)
    );

    fieldsToEmpty.forEach((row) => {
      setFieldValue(`dynamicFields.din_${row.property.id}`, '');
    });
  } catch (e) {
    console.error('Error in emptyDynFieldsAfterCopy:', e);
  }
};
